






































































































import {mapActions, mapGetters} from 'vuex';
import profilePicture from '@/components/profile/ProfilePicture.vue';
import {emptyAdvert} from '@/store/modules/Advert/state';
import Vue from 'vue';
import {TranslateResult} from 'vue-i18n';
import {CategoryAPI} from '#/Category';
import {Advert} from '#/Advert';

interface ComponentData {
  abuseDisplay: boolean;
  advertLocal: Advert;
  hasPictureLoaded: boolean;
  noAdvert: boolean;
}

export default Vue.extend({
  name: 'AdvertDetail',

  components: {
    'admin-advert': () => import('@/components/advert/Admin.vue'),
    'availability': () => import('@/components/advert/Availability.vue'),
    'participants-limit': () => import('@/components/advert/ParticipantsLimit.vue'),
    'period-at': () => import('@/components/advert/PeriodAt.vue'),
    'tag-content': () => import('@/components/advert/TagContent.vue'),
    profilePicture,
  },

  props: {
    advertId: {
      required: true,
    },
  },

  data: (): ComponentData => ({
    abuseDisplay: false,
    /** @type {Advert} */
    advertLocal: {
      ...emptyAdvert(),
    },
    hasPictureLoaded: false,
    noAdvert: false,
  }),

  computed: {
    ...mapGetters([
      'advert',
      'isAdmin',
      'profile',
      'blacklist',
    ]),
    canContact(): boolean {
      return !this.isAuthor && this.blacklist.every((bl: { id: number }) => bl.id !== this.advert.author.id);
    },
    displayMetadata(): boolean {
      return !!this.advertLocal.startsAt || !!this.advertLocal.availability || !!this.advertLocal.participantsLimit;
    },
    hasCategory(): boolean {
      return this.advertLocal.categories && this.advertLocal.categories.length > 0;
    },
    isAuthor(): boolean {
      return this.advertLocal.author.id === this.profile.id;
    },
    periodTraduction(): TranslateResult | string {
      return this.advertLocal.id !== null && this.advertLocal.availability !== null
          ? this.$t(`advert.creation.fields.period.periodEnum.${this.advertLocal.availability}`)
          : '';
    },
  },

  created() {
    this.updatePageTitle('');
    this.updateAppBarContext({
      status: true,
      type: 'advertDetail',
    });

    this.loadCategories();
    this.loadAdvert(this.advertId)
        .then(() => {
          if (this.advert.error === undefined) {
            const {content, ...rest} = this.advert as Advert;
            this.advertLocal = {
              ...rest,
              content: content.replace(
                  /((?:href=")?(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9]{1,6}\b[-a-zA-Z0-9()@:%_+.~#?&/=]*)/g,
                  (match): string => {
                    if (match.match('href')) return match;
                    if (match.match('http')) return `<a href="${match}" target="_blank">${match}</a>`;

                    return `<a href="https://${match}" target="_blank">${match}</a>`;
                  },
              ),
            };
            this.updatePageTitle(this.advertLocal.title);
          }
        })
        .catch(error => {
          (error.response?.status === 404)
              ? this.noAdvert = true
              : this.displayError(error.response);
        });
    this.hasPictureLoaded = !!this.advert.author.profilePhoto;
  },
  methods: {
    ...mapActions([
      'displayError',
      'getUsernameInJWT',
      'loadAdvert',
      'loadCategories',
      'reportAdvert',
      'updateAppBarContext',
      'updatePageTitle',
    ]),
    onAuthorClick(authorId: number): Promise<void> {
      return new Promise((resolve, reject) => {
        if (!this.isAuthor) {
          this.$router.push({
            name: 'AuthorDetail',
            params: {authorId: `${authorId}`},
          })
              .then(() => {
                resolve();
              })
              .catch(() => {
                reject();
              });
        }
      });
    },
    onConfirmReport() {
      this.reportAdvert(this.advertId)
          .then(() => {
            this.abuseDisplay = false;
          });
    },
    onSelectCategory(selectedCategory: CategoryAPI): Promise<void> {
      return new Promise((resolve, reject) => {
        this.$router.push({
          name: 'AdvertList',
          query: {category: `${selectedCategory.id}`},
        })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
    onSendMessage(): Promise<void> {
      return new Promise((resolve, reject) => {
        this.$router.push({
          name: 'MessageDetail',
          params: {
            userId: `${this.advertLocal.author.id}`,
            advertId: `${this.advertLocal.id}`,
          },
        })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            });
      });
    },
  },
});
